import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { resetALL } from "../../../../../../../.globals/redux/actions";
import { NotificationManager } from "../../../../../../../components/Notifications";

const INIT_STATE = {
  open: false,
  loading: false,
  result: null,
  error: null,
  deleteVehicleStatusList: []
};

const route = "modules/manage/modals/deleteManageVehicleStatus/redux/slice";

export const manageDeleteManageVehicleStatus = createAsyncThunk(
  "manage/deleteManageVehicleStatus/deleteManageVehicleStatus",
  async (payload, { rejectWithValue }) => {
    const mutations = [];
    try {
      const { items } = payload;
      if (items?.length) {
        items?.forEach((item, index) => {
          mutations.push(`
                    DeleteVehicleStatus${index}: deleteVehicleStatus(id: ${item?.id})
                `);
        });
        const mutation = `mutation { ${mutations.join(" ")} }`;
        const response = await clientMutation(mutation, {}, endpoints.GRAPHQL_GENERAL);
        if (response?.DeleteVehicleStatus0) return response.DeleteVehicleStatus0;
        else throw "Error while deleting manage Vehicle Status";
      }
    } catch (exc) {
      NotificationManager.error(
        "Error",
        `Error Deleting Manage Vehicle Status`,
        3000,
        null,
        null,
        "error"
      );
      ExceptionManager(exc, route, "deleteManageVehicleStatus");
      rejectWithValue(exc);
    }
  }
);

const manageDeleteManageVehicleStatusRedux = createSlice({
  name: "manage/deleteManageVehicleStatus",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE };
    },
    openModalDeleteManageVehicleStatus(state, action) {
      state.open = true;
      state.deleteVehicleStatusList = action?.payload?.deleteVehicleStatusList;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    // manageDeleteManageVehicleStatus
    builder.addCase(manageDeleteManageVehicleStatus.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(manageDeleteManageVehicleStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action.payload;
    });
    builder.addCase(manageDeleteManageVehicleStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  }
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageDeleteManageVehicleStatusRedux;

// Extract and export each action creator by name
export const { reset, openModalDeleteManageVehicleStatus } = actions;

// Export the reducer, either as a default or named export
export default reducer;
